//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { imageSrcHandle } from "@src/util/imgsHandle";

export default {
  name: "FloatingLayer",
  data() {
    return {
      followActive:  false,
      contactActive: false,
      contactCode: imageSrcHandle('https://img.jk.com/open-platform/contact-code.png'),
    }
  },
  methods: {
    contactUs() {
      this.$emit('contactUs')
    }
  }
}
